<template>
<!-- 会员推广 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form :model="filters" class="findform">
        <el-form-item label="渠道名称：" style="display:flex;width:35%">
          <el-input v-model="filters.channelName" placeholder="请输入渠道名称 (20字以内)" maxlength="20" style="width:90%"/>
        </el-form-item>
        <el-form-item label="状　　态：" style="display:flex;width:35%;" class="select">
          <el-select v-model="filters.stateId" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in statearr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">会员推广</p>
      <el-button type="danger" @click="addOrEditBrand()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" stripe border>
        <!-- <el-table-column label="序号" align="center">
          <template scope="scope">
            <span :title="scope.row.Id" :label="scope.row.Id" class="templateSpan">{{scope.row.Id}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="渠道名称" align="center">
          <template scope="scope">
            <span :title="scope.row.ChannelName" :label="scope.row.ChannelName" class="templateSpan">{{scope.row.ChannelName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效时间" align="center">
          <template scope="scope">
            <span :title="scope.row.ExpireTime" :label="scope.row.ExpireTime" class="templateSpan">{{scope.row.ExpireTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="引流数" align="center">
          <template scope="scope">
            <span :title="scope.row.DrainageNumber" :label="scope.row.DrainageNumber" class="templateSpan">{{scope.row.DrainageNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template scope="scope">
            <span :title="scope.row.CTime" :label="scope.row.CTime" class="templateSpan">{{scope.row.CTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="center">
          <template scope="scope">
            <span :title="scope.row.OperatorName" :label="scope.row.OperatorName" class="templateSpan">{{scope.row.OperatorName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">
            <span :title="scope.row.StatusName" :label="scope.row.StatusName" class="templateSpan">{{scope.row.StatusName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="236" align="center">
          <template scope="scope">
            <span v-if="scope.row.StatusId == 1" @click="scopeExtension(scope.row)" class="handle"> <i class="el-icon-share"/> 推广 </span>
            <span v-if="scope.row.StatusId != 3" @click="cardStatus(scope)" class="handle">
              <i :class="scope.row.StatusId == 1?'el-icon-circle-close':'el-icon-circle-check'"/>
              {{scope.row.StatusId == 1?"禁用":"启用"}}
            </span>
            <span v-if="scope.row.StatusId != 3" @click="addOrEditBrand(scope.row)" class="handle"> <i class="el-icon-edit-outline"/> 编辑 </span>
            <span v-if="scope.row.StatusId == 3" @click="seeDetails(scope.row)" class="handle"> <i class="el-icon-view"/> 查看 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 新增/编辑推广-弹框 -->
  <el-dialog title="推广管理" :visible.sync="isToExamine" :center="true" class="add_order_cancle" width="30%">
    <el-form>
      <el-form-item label="渠道名称 :" style="width:80%" label-width="80px">
        <el-input :disabled="seeDis" v-model="brandName" placeholder="请输入渠道名称 (20字以内)" maxlength="20"/>
      </el-form-item>
      <el-form-item label="有效期 :" style="width:80%;" label-width="80px">
        <el-date-picker type="date" v-model="value6" :editable="false" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
            placeholder="选择日期" style="width:76%;cursor:pointer;" :disabled="seeDis || IsNoLimit == 1"/>
        <el-checkbox :disabled="seeDis" v-model="IsNoLimit" style="float: right;">长期有效</el-checkbox>
      </el-form-item>
      <el-form-item label="备注 :" style="width:80%;" label-width="80px">
        <el-input type="textarea" v-model="anwser" placeholder="请输入备注：" :disabled="seeDis"
          :autosize="{ minRows: 2, maxRows: 8}" maxlength="150" show-word-limit/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="text-align:center">
      <el-button @click="isToExamine = false">取消</el-button>
      <el-button type="danger" @click="editSubmit()" v-show="chakan">保存</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { getChannelPromotionList, getInsertChannelPromotion, getUpdateChannelPromotion,
getUpdateChannelPromotionStatus, getGeneratedChannelPromotionQrCode, getkind } from "../../api/api";
export default {
  name: "MembershipCardPromotion",
  mixins: [alertTrends],
  data() {
    return {
      dataId: "",
      membershipCardId: "",
      show3: true, // 查询区域默认展开
      statearr: [],
      isToExamine: false, // 会员卡推广弹框
      brandName: "", // 渠道名称,
      value6: "",
      IsNoLimit: true, // 长期有效 默认勾选
      anwser: '', // 备注
      seeDis: false, // 置灰
      chakan: true, // 保存按钮 默认展示
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      filters: {
        channelName: "", // 渠道名称
        stateId: 0, // 状态
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      cardId: "",
      onOffState: ""
    }
  },
  methods: {
    //查询列表
    getDataAnalysis() {
      let addParams = {
        channelName: this.filters.channelName, // 渠道名称
        statusId: this.filters.stateId, // 	状态id
        pageIndex: this.pageIndex,// 分页数据 当前页码
        pageSize: this.pageSize // 分页数据 每页显示条数
      };
      getChannelPromotionList(addParams).then(data => {
        this.dataList = data.ResultObj;
        this.total = data.RowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 触发 编辑按钮 & 新增按钮 是否回显
    addOrEditBrand(row) {
      // 如果有数据就是编辑 否则就是新增
      if (row) {
        this.membershipCardId = row.Id;
        this.chakan = true;
        this.seeDis = false;
        this.brandName = row.ChannelName; // 渠道名称
        this.IsNoLimit = row.IsPermanate; // 是否长久有效，0=否；1=是
        if(this.IsNoLimit == 1) {
          this.IsNoLimit = true;
        } else {
          this.IsNoLimit = false;
          this.value6 = row.ExpireTime.split('.').join('-'); // 有效期
        }
        this.anwser = row.Remark; // 备注
      } else {
        this.membershipCardId = ""; // 新增进来 吧id置空
        this.chakan = true;
        this.seeDis = false;
        this.brandName = ""; // 渠道名称
        this.value6 = ""; // 有效期
        this.IsNoLimit = true;
        this.anwser = ""; // 备注
      }
      this.isToExamine = true; // 会员卡推广详情弹框展示
    },
    // 查看
    seeDetails(row) {
      console.log(row,'查看');
      this.chakan = false;
      this.seeDis = true;
      this.brandName = row.ChannelName; // 渠道名称
      this.IsNoLimit = row.IsPermanate; // 是否长久有效，0=否；1=是
      if(this.IsNoLimit == 1) {
        this.IsNoLimit = true;
      } else {
        this.IsNoLimit = false;
        this.value6 = row.ExpireTime.split('.').join('-'); // 有效期
      }
      this.anwser = row.Remark; // 备注
      this.isToExamine = true; // 会员卡推广详情弹框展示
    },
    // 推广
    scopeExtension(row) {
      var obj = {
        channelId: row.Id, // 渠道id
        channelName: row.ChannelName, // 渠道名称
      }
      getGeneratedChannelPromotionQrCode(obj).then(data=>{
        if(data.ResultCode == 1){
          // data.ResultObj
          let address = data.ResultObj;
          let intercept = data.ResultMsg;
          this.getUrlBase64(address).then(base64 => {
            let link = document.createElement('a')
            link.href = base64
            link.download = intercept
            link.click()
          })
          this.getDataAnalysis();
          this.showAlert('推广成功', 'success');
        }else if(data.ResultCode in {0:0,2:2}){
          this.showAlert(data.ResultMsg, 'error');
        }
      })
    },
    // getUrlBase64这个方法主要根据图片的url返回一个base64编码
    getUrlBase64(url) {
      return new Promise(resolve => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' //允许跨域
        img.src = url
        img.onload = function() {
          canvas.width = 1280
          canvas.height = 1280
          ctx.drawImage(img, 0, 0, 1280, 1280)
          let dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    },
    // 启用 & 禁用
    cardStatus(scope) {
      this.cardId = scope.row.Id;
      this.onOffState = scope.row.StatusId;
      this.$swal({
        type: "warning",
        text: scope.row.StatusId == 1 ? "是否执行禁用操作" : "是否执行启用操作",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          this.onOff()
        }
      });
    },
    // 确定执行操作
    onOff(){
      var obj = {
        userId: localStorage.Id, // 当前操作用户id
        id: this.cardId, // 渠道id
        statusId: this.onOffState == 2 ? 1 : 2 // 	开启操作=1，禁用操作=2
      }
      getUpdateChannelPromotionStatus(obj).then(data=>{
        if(data.ResultCode == 1){
          this.getDataAnalysis();
          this.showAlert('操作成功', 'success');
        }
      })
    },
    // 保存按钮
    editSubmit() {
      console.log(this.value6,'11')
      if(this.brandName == ""){
        this.showAlert('请输入渠道名称');
        return false
      }
      if (!this.IsNoLimit&& !this.value6) {
        this.showAlert('请选择有效期');
        return false
      }
      // 判断是编辑还是新增
      if (this.membershipCardId) {
        console.log('编辑 修改按钮');
        var loginParams = {
          OperatorId: localStorage.Id, // 当前操作人id
          Id: this.membershipCardId, // 渠道id
          ChannelName: this.brandName, // 渠道名称
          IsPermanate: this.IsNoLimit === true ? 1 : 0, // 是否勾选长期有效，（1=勾选，0=不勾选） 是否长久有效，1=是；0=否
          ExpireTime: this.value6, // IsPermanate为1时，值为空，否则为渠道有效时间
          Remark: this.anwser, // 备注信息，最多150字符，可空
        };
        getUpdateChannelPromotion(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.showAlert('编辑会员卡保存成功', 'success');
            this.isToExamine = false;
            this.getDataAnalysis();
          }
        })
        .catch(err => {
          console.log(err);
        });
      } else {
        console.log('新增 保存按钮');
        var loginParams = {
          OperatorId: localStorage.Id, // 当前操作人id
          ChannelName: this.brandName, // 渠道名称
          IsPermanate: this.IsNoLimit === true ? 1 : 0, // 是否勾选长期有效，（1=勾选，0=不勾选） 是否长久有效，1=是；0=否
          ExpireTime: this.value6, // IsPermanate为1时，值为空，否则为渠道有效时间
          Remark: this.anwser, // 备注信息，最多150字符，可空
        };
        getInsertChannelPromotion(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.showAlert('新增会员卡保存成功', 'success');
            this.isToExamine = false;
            this.getDataAnalysis();
          }
        })
        .catch(err => {
          console.log(err);
        });
      }
    },
    // 查询区域-状态
    getStatearr(){
      var obj = {
        tableName:"tBDChannelPromotionStatus",
        keyWord:"",
      }
      getkind(obj).then(data=>{
        if(data.ResultCode == 1){
          this.statearr = data.ResultObj;
          this.statearr.unshift({
            Id:0,
            Name:"全部"
          })
        }
      })
    },
    // 重置
    fnReset() {
      this.filters = {
        channelName: "", // 渠道名称
        stateId: 0, // 状态
      }
      // this.pageIndex = 1;
      // this.getDataAnalysis();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getDataAnalysis();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDataAnalysis();
    }
  },
  watch: {
    'IsNoLimit'(newV,oldV) {
      if(this.IsNoLimit == 1) {
        this.value6 = "";
      }
    },
  },
  created() {
    let that = this;
    // 查询列表
    setTimeout(function() {
      that.getDataAnalysis();
    }, 200);
    // 获取状态
    this.getStatearr();
  }
}
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 122px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-left: 0px;
  margin-top: 0px;
}
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
.templateSpan {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  display: block;
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// MembershipCardPromotion.vue?6a1b8f95